__turbopack_context__.v({
  "accordionSlideOverwrite": "sidebar-module-scss-module__azNl_q__accordionSlideOverwrite",
  "fadeIn": "sidebar-module-scss-module__azNl_q__fadeIn",
  "fadeOut": "sidebar-module-scss-module__azNl_q__fadeOut",
  "mapContainer": "sidebar-module-scss-module__azNl_q__mapContainer",
  "scaleIn": "sidebar-module-scss-module__azNl_q__scaleIn",
  "scaleOut": "sidebar-module-scss-module__azNl_q__scaleOut",
  "sidebar": "sidebar-module-scss-module__azNl_q__sidebar",
  "sidebarSectionContent": "sidebar-module-scss-module__azNl_q__sidebarSectionContent",
  "sidebarSectionTitle": "sidebar-module-scss-module__azNl_q__sidebarSectionTitle",
  "zoomIn": "sidebar-module-scss-module__azNl_q__zoomIn",
  "zoomOut": "sidebar-module-scss-module__azNl_q__zoomOut",
});
